import { useEffect } from 'react'
import {
  formatUnknownError,
  reportFrontendError,
} from '@/shared/monitoring/report-frontend-error'

export function FrontendErrorListeners() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      const fallbackMessage = [event.message, event.filename, event.lineno, event.colno]
        .filter(Boolean)
        .join(' | ')
      const error = formatUnknownError(event.error)

      reportFrontendError('window-error', {
        message: error.message || fallbackMessage || 'Unhandled window error',
        stack: error.stack,
        metadata: {
          filename: event.filename,
          line: event.lineno,
          column: event.colno,
        },
      })
    }

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error = formatUnknownError(event.reason)

      reportFrontendError('unhandled-rejection', {
        message: error.message,
        stack: error.stack,
      })
    }

    window.addEventListener('error', onError)
    window.addEventListener('unhandledrejection', onUnhandledRejection)

    return () => {
      window.removeEventListener('error', onError)
      window.removeEventListener('unhandledrejection', onUnhandledRejection)
    }
  }, [])

  return null
}
